import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { BpService } from '../../../../core/services/bp.service';
import { AlertsService } from '../../../../core/services/alerts.service';
import { CertificateModalSignatureData } from '../../../../shared/services/signature-nca-common-utils.service';
import { RetailPlaceConnectVpnSignatureFields } from '../vpn.model';
import { RetailPlacesApiService } from '../../../../core/modules/retail-places/retail-places-api.service';

@UntilDestroy()
@Component({
  selector: 'tax-vpn-sign',
  templateUrl: './vpn-sign.component.html',
  styleUrls: ['./vpn-sign.component.sass'],
})

export class VpnSignComponent implements OnInit {
  @Input() retailPlaceData?: RetailPlaceConnectVpnSignatureFields;

  data?: CertificateModalSignatureData;

  constructor(
    private router: Router,
    private bpService: BpService,
    private retailPlacesApiService: RetailPlacesApiService,
    private alertsService: AlertsService,
  ) { }

  ngOnInit(): void {
    this.retailPlacesApiService.fetchVpnConnectDocumentBase64()
      .pipe(untilDestroyed(this))
      .subscribe((response: string) => {
        this.data = {
          doc: {
            signingDocument: response,
          },
          type: 'SIGN',
        };
      });
  }

  back(): void {
    this.router.navigate(['main/kkms']);
  }

  setSignature(modalData: CertificateModalSignatureData): void {
    // @ts-ignore
    this.retailPlaceData.signature = modalData.signature.signingDocument;
    this.bpService.submitCurrentBp(this.retailPlaceData)
      .pipe(
        switchMap(() => from(this.router.navigate(['main/kkms']))),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.alertsService.add({
          message: 'vpn.request.success',
          title: 'event.success',
          type: 'success',
        });
      });
  }
}
